import {useParams} from 'react-router'
import styles from './ResponseMetric.module.scss'
import {IDialogDetails, IResponseStat} from '../../../../../../types'
import {cx, getHexFromColorText, getTimePassed} from '../../../../../../utils'
import {WuIcon} from '@npm-questionpro/wick-ui-lib'
import {DIALOG_AVATAR_IMAGE_URL} from '../../../../../../constants/dialogConstants'
import {dialogApi} from '../../../../../../api/dialogApi'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../../../Translation/English/dialog'
import {IDEATION} from '../../../../../../Translation/English/ideation'

interface IResponseMetricProps {
  data: IResponseStat[]
  filterType: string
}
export const ResponseMetric: React.FC<IResponseMetricProps> = ({
  data,
  filterType,
}) => {
  const wt = useWt()
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: dialogDetails} = dialogApi.useDialogDetails(dialogId ?? '') as {
    data: IDialogDetails
  }

  if (!dialogDetails) return null

  const emptyStateByMetric: Record<string, string> = {
    mostLiked: DIALOG.emptyLikes,
    mostDisliked: DIALOG.emptyDislikes,
    mostCommented: DIALOG.emptyComments,
    highlighted: DIALOG.emptyHighlights,
  }

  const getStats = (response: IResponseStat): React.ReactElement => {
    return (
      <>
        {dialogDetails.enableLikes && (
          <>
            <WuIcon icon="wm-thumb-up" color="primary" />
            {response.likeCount || 0}{' '}
            {response.likeCount === 1 ? wt(DIALOG.like) : wt(DIALOG.likes)}
          </>
        )}
        {dialogDetails.enableDislikes && (
          <>
            <WuIcon icon="wm-thumb-down" color="primary" />
            {response.dislikeCount || 0}{' '}
            {response.dislikeCount === 1
              ? wt(DIALOG.dislike)
              : wt(DIALOG.dislikes)}
          </>
        )}
        {dialogDetails.enableResponse && (
          <>
            <WuIcon icon="wm-comment" color="primary" />
            {response.replyCount || 0}{' '}
            {response.replyCount === 1
              ? wt(IDEATION.comment)
              : wt(DIALOG.comments)}
          </>
        )}
      </>
    )
  }

  return (
    <div className={styles.responseMetric}>
      {data.map(response => (
        <>
          <div className={styles.responseMetricWrapper}>
            <div className={styles.responseMetricStats}>
              <div className={styles.responseMetricUserDetails}>
                <div
                  className={cx(
                    styles.responseMetricAvatar,
                    response.isModerator &&
                      styles.responseMetricAvatarModerator,
                  )}
                >
                  {response.isModerator ? (
                    <div>M</div>
                  ) : (
                    <img
                      src={`${DIALOG_AVATAR_IMAGE_URL}${response.dialogUserAvtar.username}`}
                      alt="coverImage"
                      width={'100%'}
                      height={'100%'}
                      loading="lazy"
                      className={styles.responseMetricAvatarImg}
                      style={{
                        backgroundColor: getHexFromColorText(
                          response.dialogUserAvtar?.username?.split(' ')[0] ??
                            '',
                        ),
                      }}
                    />
                  )}
                </div>
                <div className={styles.responseMetricUsername}>
                  {response.isModerator
                    ? wt(DIALOG.moderator)
                    : response.dialogUserAvtar?.username}
                </div>
                <div className={styles.responseMetricTimestamp}>
                  {response.createdAt ? getTimePassed(response.createdAt) : ''}
                </div>
              </div>
              {filterType !== 'highlighted' && (
                <div className={styles.responseMetricValue}>
                  {getStats(response)}
                </div>
              )}
            </div>
            <div className={styles.responseMetricText}>{response.text}</div>
          </div>
        </>
      ))}
      {data.length === 0 && (
        <div className={styles.responseMetricEmpty}>
          {wt(emptyStateByMetric[filterType] || DIALOG.emptyComments)}
        </div>
      )}
    </div>
  )
}
